/// <amd-module name="Core/Medius.Core.Web/Scripts/lib/uniqueId"/>
let id = 0;

export function getId() {
    id += 1;
    return id;
}
